import { render, staticRenderFns } from "./ruler.vue?vue&type=template&id=0fee7ac8&"
import script from "./ruler.vue?vue&type=script&lang=js&"
export * from "./ruler.vue?vue&type=script&lang=js&"
import style0 from "./ruler.vue?vue&type=style&index=0&id=0fee7ac8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports